module.exports = __webpack_public_path__ + "img/app-store-02@2x.965a004d.png";